import { Box, Button } from '@mui/material'
import { useEffect, useState } from 'react';
import { MenuIcon } from '../../../../../core/icon/__refactored/Icon';
import { env } from '../../../../../core/Env';
import { rqx } from '../../../../../core/request/API';
import { SnakeLoader } from '../../../../../core/loader/SnakeLoader';
import { CreateFeatureLogs } from '../../../../../core/request/Global';
import { FeatureIdState } from '../../../toolUsage/global/GlobalFcn';

export const Quiz = ({openWidth, wideHandler, information_state, uid, nav, tool_state}) => {
    let urlParams = new URLSearchParams(window.location.search);
    const [ans, setAns] = useState([])
    const [act, setAct] = useState(false)
    const [selectCategory, setselectCategory] = useState([])
    const [correctAnswers, setCorrectAnswers] = useState(0);
    const [validationError, setValidationError] = useState('');

    useEffect(() => {
        information_state.test.set({...information_state.test.data, name:'Quiz'})
        const __init = async()=> {
            const init = await rqx.get(`<<tool>>/${env()}/biz_exam/user_read_Quiz`, {training_id:urlParams.get('id'), ref:'trainings'})
            information_state.exam.set(init)
            const progress = await rqx.get(`<<tool>>/${env()}/biz_trainings/user_check_trainings`, {training_id:urlParams.get('id'), user_id: uid, ref:'trainings', company_id: tool_state.cinfo.data[0].company_id })
            const tContent = await rqx.get(`<<tool>>/${env()}/biz_trainings/user_training_content`, {training_id:urlParams.get('id'), ref:'trainings'})
            const updatedProg = { pretest: 1, vl: 1, quiz: 0, posteval: 0 };
            progress.forEach(item => {
                if (item.exam_type === 1) {
                // pretest
                updatedProg.pretest = item.exam_type === 1 ? 1 : 0;
                } else if (item.exam_type === 2) {
                // quiz
                updatedProg.quiz = item.exam_type === 2 ? 1 : 0;
                } else if (item.exam_type === 3) {
                // post eval
                updatedProg.posteval = item.exam_type === 3 ? 1 : 0;
                } else if (item.exam_type === 4) {
                // video Lesson
                updatedProg.vl = item.exam_type === 4 ? 1 : 0;
                }
            });
            information_state.prog.set(updatedProg)
            information_state.tc.set({...information_state.tc.data, pretest:tContent[0].pretest_id !== null ? 1 : null, quiz:tContent[0].quiz_id !== null? 1: null, posteval:tContent[0].post_evaluation_id !== null ? 1 : null})
        }
        __init()
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])
    
    const handleClick = (e, id, q, k, kk, choice, correct) => {
        e.preventDefault()
        if (act !== true) {
            const isCorrect = correct === choice ? 1 : 0 
            let a = [...ans]
            a[k] = {question_id: id, question: q, ans: choice, answer_status: isCorrect }
            setAns(a)
            let b = [...selectCategory]
            b[k] = kk
            setselectCategory(b)
            let err = [...validationError]
            err[k] = false
            if(correct === choice) {
                setCorrectAnswers((prevCount)=> prevCount + 1)
            }
        }
    }
    
    const handleSubmit = () => {
        const correctCount = ans.filter(a => a && a.answer_status === 1).length;
        setCorrectAnswers(correctCount);

        const allAnsweredStatus = information_state.exam.data.exam.map((q, k) => {
            if (ans[k] && ans[k].ans !== '') {
                return false;
            } else {
                return true;
            }
        });

        if (allAnsweredStatus.includes(true)) {
            setValidationError(allAnsweredStatus);
            return;
        } else {
            setValidationError(allAnsweredStatus);
        }
        let passedfailed;
        if(parseFloat(correctAnswers/(information_state.exam.data.exam.length/100).toFixed(2)) >= 80) {
            passedfailed = 1
        } else {
            passedfailed = 0
        }
        const data ={
          user_id:uid,
          exam_type:2,
          progress_status:passedfailed,
          training_id:urlParams.get('id'),
          data:ans,
          company_id: tool_state.cinfo.data[0].company_id
        }
        _init(data)
    }

    const _init = async(data)=>{
        // eslint-disable-next-line
        let res = { 
            aid: tool_state.__SESSION.data.ainfo.aid,
            path: `${FeatureIdState('assessment')}->2`,
            feature_id: FeatureIdState('assessment'),
            feature_name: 'assessment-quiz',
            tid: parseInt(process.env.REACT_APP_TID_BIZ),
            company_id: tool_state.cinfo.data[0].company_id,
            action: 1,
        } 
        await CreateFeatureLogs(res)
        await rqx.post(`<<tool>>/${env()}/biz_exam/user_update_status`, data)
        const init = await rqx.post(`<<tool>>/${env()}/biz_exam/exam_create`, data)
        
        if (init.message === 'success') {
            setAct(true)
        } else {
            console.log('ERRRRRRRRROOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOORRRRRRRRRRRRRRRRRRRRRRR')
            // setAct(true)
        }
    }
    const handleProceed = () => {
        nav.push(`/biz/take-training/post-evaluation?id=${urlParams.get('id')}`)
    }
    const handleRetake = () => {
        setCorrectAnswers(0)
        setselectCategory([])
        setAns([])
        setAct(false)
    }

    return (
        <Box p="40px" display="flex" flexDirection="column" width="100%" height="100%">
            <Box width="100%" height="100%">
                <Box display="flex" justifyContent="space-between" alignItems="center">
                    <Box fontSize={14} fontWeight={400} lineHeight="22.65px">Direction: Choose the letter of the correct answer.</Box>
                    { !openWidth.data && (
                        <Box display="flex" className='c-pointer' onClick={wideHandler}>
                            <MenuIcon />
                            <Box fontSize={14} fontWeight={600} lineHeight="22.65px" color="#1893F1" ml="12px">Show menu</Box>
                        </Box>
                        )
                    }
                </Box>
                { act === true && (
                    <Box border="1px solid #E5EBF6" bgcolor="#1893F1" borderRadius="8px" p="24px 16px 24px 16px" mt="24px" width="100%">
                        <Box fontSize="P-300" lineHeight="23px" color="#E3F2FD">You have reached {correctAnswers} of {information_state.exam.data.exam.length} point(s), ({parseFloat(correctAnswers/(information_state.exam.data.exam.length/100).toFixed(2))}%)</Box>
                    </Box>
                )}
                { act === true ? (
                        parseFloat(correctAnswers/(information_state.exam.data.exam.length/100).toFixed(2)) >= 80 ? (
                            <Box border="1px solid #E5EBF6" bgcolor="#F5F8FF" borderRadius="8px" p="24px" mt="24px" width="100%">
                                <Box fontSize="P-400" color="#000">Congratulations! You passed the quiz. You are one step closer on becoming Extraordiany Professional.</Box>
                                <Box mt="24px" fontSize="P-300" color="#1893F1">Take the Post Evaluation and generate your certificate.</Box>
                            </Box>
                        ) : (
                            <Box border="1px solid #E5EBF6" bgcolor="#FFEBEE" borderRadius="8px" p="24px" mt="24px" width="100%">
                                <Box fontSize="P-400" color="#000">Sorry you didn’t passed the quiz. </Box>
                                <Box mt="24px" fontSize="P-300" color="#000">You still have a chance to become extraordinary.</Box>
                            </Box>
                        )
                    ) : (
                        information_state.exam.data !== undefined ? (
                            information_state.exam.data.exam.map((q, k) => (
                                <Box key={k} border="1px solid #E5EBF6" borderRadius="6px" p="24px" mt="24px" width="100%">
                                    <Box fontSize={14} fontWeight={600} lineHeight="22px">Question no. {k + 1}</Box>
                                    <Box fontSize={14} fontWeight={400} lineHeight="22px" mt="24px" mb="8px">{q.question}</Box>
                                    {
                                        q.choices.map((v, kk)=>(
                                            <Box key={kk} display='flex' width="100%" mt="16px" onClick={(e)=>handleClick(e, q.question_id, q.question, k, kk, v.key, q.correct)} >
                                                <Box display="flex" alignItems="center" width="100%" sx={{textAlign: 'start', '&:hover': {'& > div:first-of-type': {bgcolor: '#E3F2FD',}, },}}>
                                                    <Box border="1px solid #E5EBF6" borderRadius="100%" bgcolor= { act === false ? (selectCategory[k] === kk && '#E3F2FD') : ( selectCategory[k] === kk && q.correct === ans[k].ans ? '#E8F5E9' : ( selectCategory[k] === kk && q.correct !== ans[k].ans ? '#FFEBEE' : ( q.correct === v.key && '#E8F5E9' ) ) )}  color= { act === false ? (selectCategory[k] === kk && '#1893F1') : ( selectCategory[k] === kk && q.correct === ans[k].ans ? '#008F5D' : ( selectCategory[k] === kk && q.correct !== ans[k].ans ? '#FA3E3E' : ( q.correct === v.key && '#008F5D' ) ) ) } p="8px 12px 8px 12px" >
                                                        <Box fontSize={14} fontWeight={600}>{v.key}</Box>
                                                    </Box>
                                                    <Box border="1px solid #E5EBF6" borderRadius="6px" bgcolor= { act === false ? (selectCategory[k] === kk && '#E3F2FD') : ( selectCategory[k] === kk && q.correct === ans[k].ans ? '#E8F5E9' : ( selectCategory[k] === kk && q.correct !== ans[k].ans ? '#FFEBEE' : ( q.correct === v.key && '#E8F5E9' ) ) )}  color= { act === false ? (selectCategory[k] === kk && '#1893F1') : ( selectCategory[k] === kk && q.correct === ans[k].ans ? '#008F5D' : ( selectCategory[k] === kk && q.correct !== ans[k].ans ? '#FA3E3E' : ( q.correct === v.key && '#008F5D' ) ) ) }  className='choices' p="12px" width="100%" ml="16px" >
                                                        <Box fontSize={14} fontWeight={600}>{v.value}</Box>
                                                    </Box>
                                                </Box>
                                            </Box>
    
                                        ))
                                    }
                                </Box>
                            ))
                        ) : (
                            <Box display="flex" justifyContent="center">
                                <SnakeLoader size="0.7rem" bg="#0170EC" distance="0.3rem" />
                            </Box>
                        )
                    )
                }
                <Box display="flex" justifyContent="flex-end" my="24px">
                    {
                        act === false ? (
                            <Box component={Button} onClick={(e) => handleSubmit(e)} variant='contained'>Submit</Box>
                        ) : (
                            parseFloat(correctAnswers/(information_state.exam.data.exam.length/100).toFixed(2)) >= 80 ? (
                                <Box component={Button} onClick={(e) => handleProceed(e)} variant='contained'>Next</Box>
                            ) : (
                                <Box component={Button} onClick={(e) => handleRetake(e)} variant='contained'>Retake</Box>
                            )
                        )
                    }
                </Box>
            </Box>
        </Box>
    )
}
